import { useEffect, useState } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IResDashboard, OrdersByStatus } from '@/types/parcel/dashboard';

import { useDate } from '../Context/DateContext';

interface StateData {
  data: OrdersByStatus['ordersByStatus'] | null;
  isLoading: boolean;
  isError: boolean;
}

const showStatus = [
  'Borrador',
  'Lista para recolección',
  'En recolección',
  'En revisión',
  'Almacenado',
  'Entregado',
];

const period = {
  today: 'Hoy',
  last48hours: 'Últimas 48 horas',
  last7days: 'Últimos 7 días',
  last30days: 'Últimos 30 días',
};

const useShipmentBreakdown = () => {
  const { selectedDate, dateType } = useDate();
  const [data, setData] = useState<StateData>({
    data: null,
    isLoading: true,
    isError: false,
  });

  const getBreakdownData = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.dashboard.orderByStatus(selectedDate);
      setData({
        data: (response as IResDashboard<OrdersByStatus>).data.ordersByStatus.filter((item) =>
          showStatus.includes(item.statusGroupES),
        ),
        isLoading: false,
        isError: false,
      });
    } catch {
      setData({ data: null, isLoading: false, isError: true });
    }
  };

  useEffect(() => {
    getBreakdownData();
  }, [selectedDate]);

  return {
    data,
    selectedDate,
    periodDate:
      dateType == 'custom'
        ? `${selectedDate.startDate} - ${selectedDate.endDate}`
        : period[dateType],
  };
};

export default useShipmentBreakdown;
